import { Typography } from '@mui/material'
import { ReactNode } from 'react'

export const SectionTitle = ({ children, icon }: { children: ReactNode; icon: ReactNode }) => (
  <Typography
    variant="h6"
    component="h2"
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      fontWeight: 'bold',
    }}
  >
    {icon}
    {children}
  </Typography>
)
